﻿export const marketingPreferences = () => {
    const selectedClass = 'selected';

    const createNewEvent = eventName => {
        let event;
        if (typeof (Event) === 'function') {
            event = new Event(eventName, { bubbles: true });
        } else {
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }
        return event;
    };

    const unselectBoth = toggles => {
        toggles.forEach(toggle => {
            toggle.classList.remove(selectedClass);
        });
    };

    const handleToggle = (buttons, field) => event => {
        event.preventDefault();

        const button = event.currentTarget;

        const switchingOn = !button.classList.contains(selectedClass);

        unselectBoth(buttons);

        if (switchingOn) {
            button.classList.add(selectedClass);
        }

        field.value = switchingOn ? button.getAttribute('data-val') : null;
        field.dispatchEvent(createNewEvent('input'));
    };

    const init = component => {

        const toggleSwitches = component.querySelectorAll('.toggle-switch');

        [...toggleSwitches].forEach(toggle => {

            const field = toggle.querySelector('.js-field');
            const buttons = [...toggle.querySelectorAll('[data-val]')];
            
            buttons.forEach(button => {
                button.addEventListener('click', handleToggle(buttons, field));
            });
        });
    };

    return {
        init,
        selector: '[data-component="marketing-preferences"]'
    };
};